import React from "react";
import styles from "./GitStats.module.css";
import GitHubCalendar from "react-github-calendar";
import ReactTooltip from "react-tooltip";

const GitStats = () => {
  return (
    <div>
      <div className={styles.gitCalMain}>
        <h1>Github Stats</h1>
        <div className={styles.gitCal}>
          <GitHubCalendar
            username="aayyuusshh21"
            fontSize={20}
            style={{ margin: "auto" }}
            blockSize={20}
            transformTotalCount
          >
            <ReactTooltip delayShow={20} html />
          </GitHubCalendar>
        </div>
        <div className={styles.stats}>
          <img
            src="https://streak-stats.demolab.com/?user=aayyuusshh21&theme=github-dark&hide_border=true&date_format=M%20j%5B%2C%20Y%5D"
            alt=""
          />
          <img
            src="https://github-readme-stats.vercel.app/api?username=aayyuusshh21"
            alt=""
          />
        </div>
      </div>
    </div>
  );
};

export default GitStats;
